import { apiFuns, get, put, del } from "sw-hic";
let { genStandard } = apiFuns;
const api = {
  Patient: genStandard("patient", "/api/patient", true),
  Consultation: {
    ...genStandard("consultation", "/api/ip"),
  },
  Hospitalization: genStandard("hospitalization", "/api/ip"),
  Advice: {
    ...genStandard("advice", "/api/ip"),
    createGroup: (ids) => apiFuns.post(`/api/ip/advice/grouping`, { ids }),
    putAdviceSta: (ids, state, ipDiagnosisId) => apiFuns.put(`/api/ip/advice/state/${state}`, { ids, ipDiagnosisId }),
    delGroup: (id) => apiFuns.del(`/api/ip/advice/grouping/${id}`),
    copy: (id) => apiFuns.post(`/api/ip/advice/${id}/copy`),
    Group: (para) => {
      if (para.id) return apiFuns.put(`/api/ip/advice/group/${para.id}`, para);
      else return apiFuns.post(`/api/ip/advice/group`, para);
    },
    addAdviceBatch: (para) => apiFuns.post(`/api/ip/advice/batch`, para),

    Herbal: {
      save: (para) => {
        if (!para.id) return apiFuns.post(`/api/ip/advice/herbal`, para);
        else return apiFuns.put(`/api/ip/advice/herbal/${para.id}`, para);
      },
      get: (id) => apiFuns.get(`/api/ip/advice/herbal/${id}`),
    },
    action: (condition, action) => apiFuns.put(`/api/ip/advice/action/${action}`, condition),
    back: (id) => apiFuns.put(`/api/ip/advice/${id}/back`),
    print: (para) => apiFuns.get(`/api/ip/advice/print`, para), // 打印
  },
  AdviceLog: genStandard("adviceLog", "/api/ip"),
  NursingItem: genStandard("nursingItem", "/api/ip"),
  Standard: {
    ...genStandard("standard", "/api/ml"),
  },
  StantdSet: {
    ...genStandard("set", "/api/ml"),
  },
  Ml: {
    ...genStandard("item", "/api/ml"),
    getTree: (para) => apiFuns.get(`/api/ml/item`, para),
    // itemTree: (para) => apiFuns.get(`/api/ml/item/itemTree`, para),
  },
  DrugStorehouse: genStandard("storehouse", "/api/drug"), //库房
  Drug: {
    getDrugs: (para) => apiFuns.get(`/api/drug/stock/rp`, para),
  },
  AdvicePackage: genStandard("advicePackage", "/api/ip"),
  Diagnosis: {
    ...genStandard("diagnosis", "/api/patient"),
    primary: (id) => apiFuns.put(`/api/patient/diagnosis/${id}/primary`),
  },
  Disease: genStandard("diseaseICD10", "/api/md"),
  VitalSigns: genStandard("vitalSigns", "/api/ip"),
  AdviceIssued: genStandard("issued", "/api/ip/advice"),
};
export default api;
